import React from 'react';
import cn from 'classnames';

export const AgreementLogo = ({ agreementNumber, ...props }) => {
    const [loaded, setLoaded] = React.useState(false);
    const handleLoad = () => setLoaded(true);
    const handleError = event => {
        event.target.src = 'https://static.e-conomic.com/secure/agreement_logo_default.svg';
    };

    const className = cn(
        'h-10 w-10 rounded-full flex-shrink-0',
        {
            visible: loaded,
        },
        props.className
    );

    return (
        <img
            {...props}
            className={className}
            src={`${process.env.ECONOMIC_PATH}/internal-api/agreements/logo/${agreementNumber}`}
            onLoad={handleLoad}
            onError={handleError}
            alt="Company logo"
        />
    );
};
